import React, { useEffect, useRef } from 'react'
import {
  IonContent,
  IonSkeletonText
} from '@ionic/react'
import AdvertisementSkeleton from '../../../components/skeletons/AdvertisementSkeleton'
import './styles.scss'

const LoadingLive = () => {
  return (
    <IonContent
      fullscreen
      className='loading-live page-wrapper'
    >
      <div className='flexible-width-content'>
        <AdvertisementSkeleton />
        <h1>
          <IonSkeletonText className='title' animated />
        </h1>
        <IonSkeletonText className='video' animated />
        <AdvertisementSkeleton />
      </div>
    </IonContent>
  )
}

export default LoadingLive
